import SEO from "@/components/SEO";
import { PageHero, Section } from "@/components/sections";
import LeadForm from "@/components/LeadForm";
import { Mail, Phone, MapPin, Clock } from "lucide-react";

export default function Contact() {
  return (
    <div>
      <SEO path="/contact" title="Contact" description="Talk to Rao Investment Solutions. Request a callback for financial solutions for businesses or wealth solutions for individuals." />
      <PageHero
        label="Contact"
        title="Let's talk."
        intro="Tell us a little about your goals and we'll get back within one business day."
        breadcrumbs={[{ name: "Home", to: "/" }, { name: "Contact" }]}
      />

      <Section className="!pt-0">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="space-y-8">
              <ContactRow icon={Phone} label="Phone" value="+91 75067 84004" href="tel:+917506784004" />
              <ContactRow icon={Mail} label="Email" value="info@raoinvestmentsolution.com" href="mailto:info@raoinvestmentsolution.com" />
              <ContactRow icon={MapPin} label="Office" value="Mumbai, India" note="By appointment" />
              <ContactRow icon={Clock} label="Hours" value="Mon–Sat · 10:00–19:00 IST" />
            </div>
            <div className="mt-10 p-6 bg-navy text-white/70 font-data text-xs leading-relaxed">
              Prefer to talk first? Call or email us directly — the form is simply the quickest way to
              give us the context before we do.
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="bg-white border border-navy/10 p-8 md:p-10">
              <LeadForm title="Request a callback" />
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}

const ContactRow = ({ icon: Icon, label, value, note, href }) => (
  <div className="flex items-start gap-4">
    <Icon className="w-6 h-6 text-orange shrink-0 mt-1" strokeWidth={1.5} />
    <div>
      <div className="font-sans text-xs uppercase tracking-[0.2em] text-slate">{label}</div>
      {href ? (
        <a href={href} className="block font-serif text-xl text-navy mt-1 hover:text-orange transition-colors">{value}</a>
      ) : (
        <div className="font-serif text-xl text-navy mt-1">{value}</div>
      )}
      {note && <div className="font-data text-xs text-slate mt-1">{note}</div>}
    </div>
  </div>
);
